/**
 * BIP39 mnemonic helpers — 24 parole / 256 bit entropia.
 *
 * Standard noto, compatibile con hardware wallet, password manager, ecc.
 */

import { generateMnemonic, mnemonicToSeedSync, validateMnemonic } from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english';

/**
 * Genera una mnemonic da 24 parole (256 bit di entropia).
 */
export function newMnemonic() {
  return generateMnemonic(wordlist, 256);
}

/**
 * Valida formato e checksum di una mnemonic.
 */
export function isValid(phrase) {
  try {
    return validateMnemonic(phrase.trim().toLowerCase(), wordlist);
  } catch {
    return false;
  }
}

/**
 * Deriva 32 byte di seed dalla mnemonic.
 * Questo seed → keypair Ed25519 deterministica.
 */
export function mnemonicToSeed(phrase) {
  const clean = phrase.trim().toLowerCase();
  if (!isValid(clean)) throw new Error('MNEMONIC_INVALID');
  const seed64 = mnemonicToSeedSync(clean);
  // Usiamo i primi 32 byte per Ed25519
  return seed64.slice(0, 32);
}

/**
 * Splitta la phrase in array di parole.
 */
export function splitWords(phrase) {
  return phrase.trim().toLowerCase().split(/\s+/);
}

/**
 * Restituisce la wordlist (per autocomplete UI).
 */
export function getWordlist() {
  return wordlist;
}
